/*
 * File: CustomSearch.tsx
 * Project: a-a
 * File Created: Monday, 16th December 2024 10:47:52 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 14th October 2025 12:26:11 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import zeplinColor from '../../../theme/Color';
import CustomPopOver from '../CustomPopOver/CustomPopOver';

export default function CustomSearch({
  setProjects,
  getProjects,
}: {
  setProjects?: React.Dispatch<React.SetStateAction<any[] | undefined>>;
  getProjects?: (text: string) => void;
}) {
  const [searchText, setSearchText] = React.useState('');
  let wait = React.useRef<any>();

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    clearTimeout(wait?.current);
    const value = event.target.value;
    setSearchText(value);
    // setProjects((prev: any) => prev?.filter((val: any) => val?.name.includes(value)));
    wait.current = setTimeout(() => getProjects && getProjects(value), 1000);
  };

  return (
    <Box
      sx={{
        height: '48px',
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
      }}
    >
      <TextField
        variant='outlined'
        placeholder='Search'
        value={searchText}
        onChange={handleSearchChange}
        // onBlur={() => {
        //   setSearchText('');
        // }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <img
                width={20}
                height={20}
                src={'/assets/search-icon.svg'}
                alt='search-project'
                style={{
                  borderRadius: '14px',
                  objectFit: 'fill',
                  cursor: 'pointer',
                }}
                // onClick={handleClear}
                // style={{ imageRendering: 'pixelated',  }}
              />
            </InputAdornment>
          ),

          endAdornment: searchText ? (
            <InputAdornment
              position='end'
              onClick={() => {
                getProjects && getProjects('');
                setSearchText('');
              }}
            >
              <img
                width={20}
                height={20}
                src={'/assets/clear-input.svg'}
                alt='clear-input'
                style={{
                  borderRadius: '14px',
                  objectFit: 'fill',
                  cursor: 'pointer',
                }}

                // style={{ imageRendering: 'pixelated',  }}
              />
            </InputAdornment>
          ) : (
            ''
          ),

          sx: {
            borderRadius: '50px', // Rounded corners
            border: `1px solid ${zeplinColor.Neutral6}`,
            '&.Mui-focused': { border: `1px solid ${zeplinColor.Neutral6}` },
            // backgroundColor: '#f5f5f5', // Optional background color
          },
        }}
        sx={{
          width: '100%', // Adjust width as needed
          height: '48px',
          padding: 0,

          '& .MuiInputBase-input': {
            padding: '12px 12px',
          },
        }}
      />
    </Box>
  );
}
